"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _Access = require("./Access");
Object.keys(_Access).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Access[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Access[key];
    }
  });
});
var _AccessKey = require("./AccessKey");
Object.keys(_AccessKey).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _AccessKey[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _AccessKey[key];
    }
  });
});
var _App = require("./App");
Object.keys(_App).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _App[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _App[key];
    }
  });
});
var _Assistant = require("./Assistant");
Object.keys(_Assistant).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Assistant[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Assistant[key];
    }
  });
});
var _Bank = require("./Bank");
Object.keys(_Bank).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Bank[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Bank[key];
    }
  });
});
var _Company = require("./Company");
Object.keys(_Company).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Company[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Company[key];
    }
  });
});
var _Configuration = require("./Configuration");
Object.keys(_Configuration).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Configuration[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Configuration[key];
    }
  });
});
var _Connector = require("./Connector");
Object.keys(_Connector).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Connector[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Connector[key];
    }
  });
});
var _Country = require("./Country");
Object.keys(_Country).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Country[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Country[key];
    }
  });
});
var _Error = require("./Error");
Object.keys(_Error).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Error[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Error[key];
    }
  });
});
var _File = require("./File");
Object.keys(_File).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _File[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _File[key];
    }
  });
});
var _Generic = require("./Generic");
Object.keys(_Generic).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Generic[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Generic[key];
    }
  });
});
var _Microservice = require("./Microservice");
Object.keys(_Microservice).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Microservice[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Microservice[key];
    }
  });
});
var _Module = require("./Module");
Object.keys(_Module).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Module[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Module[key];
    }
  });
});
var _Policy = require("./Policy");
Object.keys(_Policy).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Policy[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Policy[key];
    }
  });
});
var _Role = require("./Role");
Object.keys(_Role).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Role[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Role[key];
    }
  });
});
var _SafeUser = require("./SafeUser");
Object.keys(_SafeUser).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SafeUser[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SafeUser[key];
    }
  });
});
var _Session = require("./Session");
Object.keys(_Session).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Session[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Session[key];
    }
  });
});
var _Team = require("./Team");
Object.keys(_Team).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Team[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Team[key];
    }
  });
});
var _Tenant = require("./Tenant");
Object.keys(_Tenant).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Tenant[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Tenant[key];
    }
  });
});
var _TenantConfiguration = require("./TenantConfiguration");
Object.keys(_TenantConfiguration).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _TenantConfiguration[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _TenantConfiguration[key];
    }
  });
});
var _User = require("./User");
Object.keys(_User).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _User[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _User[key];
    }
  });
});
var _WebSocket = require("./WebSocket");
Object.keys(_WebSocket).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _WebSocket[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _WebSocket[key];
    }
  });
});
var _Catalog = require("./Catalog");
Object.keys(_Catalog).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Catalog[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Catalog[key];
    }
  });
});
var _Family = require("./Family");
Object.keys(_Family).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Family[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Family[key];
    }
  });
});
var _ExtendedField = require("./ExtendedField");
Object.keys(_ExtendedField).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ExtendedField[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _ExtendedField[key];
    }
  });
});
var _Template = require("./Template");
Object.keys(_Template).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Template[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Template[key];
    }
  });
});
var _Workflow = require("./Workflow");
Object.keys(_Workflow).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Workflow[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Workflow[key];
    }
  });
});
var _Advance = require("./Advance");
Object.keys(_Advance).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Advance[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Advance[key];
    }
  });
});
var _AppliedPolicy = require("./AppliedPolicy");
Object.keys(_AppliedPolicy).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _AppliedPolicy[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _AppliedPolicy[key];
    }
  });
});
var _AuthorizingGroup = require("./AuthorizingGroup");
Object.keys(_AuthorizingGroup).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _AuthorizingGroup[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _AuthorizingGroup[key];
    }
  });
});
var _Banking = require("./Banking");
Object.keys(_Banking).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Banking[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Banking[key];
    }
  });
});
var _Collaborator = require("./Collaborator");
Object.keys(_Collaborator).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Collaborator[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Collaborator[key];
    }
  });
});
var _Currency = require("./Currency");
Object.keys(_Currency).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Currency[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Currency[key];
    }
  });
});
var _Deductible = require("./Deductible");
Object.keys(_Deductible).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Deductible[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Deductible[key];
    }
  });
});
var _DeductibleRule = require("./DeductibleRule");
Object.keys(_DeductibleRule).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _DeductibleRule[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _DeductibleRule[key];
    }
  });
});
var _Expense = require("./Expense");
Object.keys(_Expense).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Expense[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Expense[key];
    }
  });
});
var _ExpensePolicy = require("./ExpensePolicy");
Object.keys(_ExpensePolicy).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ExpensePolicy[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _ExpensePolicy[key];
    }
  });
});
var _ExpenseTemplate = require("./ExpenseTemplate");
Object.keys(_ExpenseTemplate).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ExpenseTemplate[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _ExpenseTemplate[key];
    }
  });
});
var _ExpenseType = require("./ExpenseType");
Object.keys(_ExpenseType).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ExpenseType[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _ExpenseType[key];
    }
  });
});
var _Inbound = require("./Inbound");
Object.keys(_Inbound).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Inbound[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Inbound[key];
    }
  });
});
var _JournalEntry = require("./JournalEntry");
Object.keys(_JournalEntry).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _JournalEntry[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _JournalEntry[key];
    }
  });
});
var _LedgerAccount = require("./LedgerAccount");
Object.keys(_LedgerAccount).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _LedgerAccount[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _LedgerAccount[key];
    }
  });
});
var _LedgerAccountStructure = require("./LedgerAccountStructure");
Object.keys(_LedgerAccountStructure).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _LedgerAccountStructure[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _LedgerAccountStructure[key];
    }
  });
});
var _PayableDocument = require("./PayableDocument");
Object.keys(_PayableDocument).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _PayableDocument[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _PayableDocument[key];
    }
  });
});
var _PaymentConfiguration = require("./PaymentConfiguration");
Object.keys(_PaymentConfiguration).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _PaymentConfiguration[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _PaymentConfiguration[key];
    }
  });
});
var _PaymentMethod = require("./PaymentMethod");
Object.keys(_PaymentMethod).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _PaymentMethod[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _PaymentMethod[key];
    }
  });
});
var _Person = require("./Person");
Object.keys(_Person).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Person[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Person[key];
    }
  });
});
var _Reconciliation = require("./Reconciliation");
Object.keys(_Reconciliation).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Reconciliation[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Reconciliation[key];
    }
  });
});
var _ReconciliationAllowance = require("./ReconciliationAllowance");
Object.keys(_ReconciliationAllowance).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ReconciliationAllowance[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _ReconciliationAllowance[key];
    }
  });
});
var _ReconciliationConfiguration = require("./ReconciliationConfiguration");
Object.keys(_ReconciliationConfiguration).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ReconciliationConfiguration[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _ReconciliationConfiguration[key];
    }
  });
});
var _ReconciliationFile = require("./ReconciliationFile");
Object.keys(_ReconciliationFile).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ReconciliationFile[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _ReconciliationFile[key];
    }
  });
});
var _ReconciliationRefund = require("./ReconciliationRefund");
Object.keys(_ReconciliationRefund).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ReconciliationRefund[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _ReconciliationRefund[key];
    }
  });
});
var _ReconciliationRefundTask = require("./ReconciliationRefundTask");
Object.keys(_ReconciliationRefundTask).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ReconciliationRefundTask[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _ReconciliationRefundTask[key];
    }
  });
});
var _Refund = require("./Refund");
Object.keys(_Refund).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Refund[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Refund[key];
    }
  });
});
var _Reset = require("./Reset");
Object.keys(_Reset).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Reset[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Reset[key];
    }
  });
});
var _Tax = require("./Tax");
Object.keys(_Tax).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Tax[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Tax[key];
    }
  });
});
var _TaxClassification = require("./TaxClassification");
Object.keys(_TaxClassification).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _TaxClassification[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _TaxClassification[key];
    }
  });
});
var _UserCompany = require("./UserCompany");
Object.keys(_UserCompany).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _UserCompany[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _UserCompany[key];
    }
  });
});
var _UserHierarchy = require("./UserHierarchy");
Object.keys(_UserHierarchy).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _UserHierarchy[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _UserHierarchy[key];
    }
  });
});
var _UserPaymentMethod = require("./UserPaymentMethod");
Object.keys(_UserPaymentMethod).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _UserPaymentMethod[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _UserPaymentMethod[key];
    }
  });
});
var _Workplace = require("./Workplace");
Object.keys(_Workplace).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Workplace[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Workplace[key];
    }
  });
});
var _Cfdi = require("./Cfdi");
Object.keys(_Cfdi).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Cfdi[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Cfdi[key];
    }
  });
});
var _Rule = require("./Rule");
Object.keys(_Rule).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Rule[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Rule[key];
    }
  });
});
var _Design = require("./Design");
Object.keys(_Design).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Design[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Design[key];
    }
  });
});
var _DesignTemplate = require("./DesignTemplate");
Object.keys(_DesignTemplate).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _DesignTemplate[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _DesignTemplate[key];
    }
  });
});
var _Message = require("./Message");
Object.keys(_Message).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Message[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Message[key];
    }
  });
});
var _Notification = require("./Notification");
Object.keys(_Notification).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Notification[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Notification[key];
    }
  });
});
var _Topic = require("./Topic");
Object.keys(_Topic).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Topic[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Topic[key];
    }
  });
});
var _Balance = require("./Balance");
Object.keys(_Balance).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Balance[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Balance[key];
    }
  });
});
var _Card = require("./Card");
Object.keys(_Card).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Card[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Card[key];
    }
  });
});
var _Statement = require("./Statement");
Object.keys(_Statement).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Statement[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Statement[key];
    }
  });
});
var _Transaction = require("./Transaction");
Object.keys(_Transaction).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Transaction[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Transaction[key];
    }
  });
});
var _Allocation = require("./Allocation");
Object.keys(_Allocation).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Allocation[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Allocation[key];
    }
  });
});
var _AllocationConfiguration = require("./AllocationConfiguration");
Object.keys(_AllocationConfiguration).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _AllocationConfiguration[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _AllocationConfiguration[key];
    }
  });
});
var _CostCenter = require("./CostCenter");
Object.keys(_CostCenter).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _CostCenter[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _CostCenter[key];
    }
  });
});
var _BudgetCompany = require("./BudgetCompany");
Object.keys(_BudgetCompany).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _BudgetCompany[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _BudgetCompany[key];
    }
  });
});
var _BudgetLine = require("./BudgetLine");
Object.keys(_BudgetLine).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _BudgetLine[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _BudgetLine[key];
    }
  });
});
var _BudgetTemplate = require("./BudgetTemplate");
Object.keys(_BudgetTemplate).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _BudgetTemplate[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _BudgetTemplate[key];
    }
  });
});
var _Budget = require("./Budget");
Object.keys(_Budget).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Budget[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Budget[key];
    }
  });
});
var _Provider = require("./Provider");
Object.keys(_Provider).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Provider[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Provider[key];
    }
  });
});
var _ErpConnection = require("./ErpConnection");
Object.keys(_ErpConnection).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ErpConnection[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _ErpConnection[key];
    }
  });
});
var _Requisition = require("./Requisition");
Object.keys(_Requisition).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Requisition[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Requisition[key];
    }
  });
});
var _RequisitionType = require("./RequisitionType");
Object.keys(_RequisitionType).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _RequisitionType[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _RequisitionType[key];
    }
  });
});
var _AuxiliarCatalog = require("./AuxiliarCatalog");
Object.keys(_AuxiliarCatalog).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _AuxiliarCatalog[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _AuxiliarCatalog[key];
    }
  });
});
var _AuxiliarCatalogItem = require("./AuxiliarCatalogItem");
Object.keys(_AuxiliarCatalogItem).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _AuxiliarCatalogItem[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _AuxiliarCatalogItem[key];
    }
  });
});
var _OnboardingUpload = require("./OnboardingUpload");
Object.keys(_OnboardingUpload).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _OnboardingUpload[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _OnboardingUpload[key];
    }
  });
});
var _BuiltinPlugin = require("./BuiltinPlugin");
Object.keys(_BuiltinPlugin).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _BuiltinPlugin[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _BuiltinPlugin[key];
    }
  });
});
var _Plugin = require("./Plugin");
Object.keys(_Plugin).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Plugin[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Plugin[key];
    }
  });
});
var _Connection = require("./Connection");
Object.keys(_Connection).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Connection[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Connection[key];
    }
  });
});
var _Destination = require("./Destination");
Object.keys(_Destination).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Destination[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Destination[key];
    }
  });
});
var _Trigger = require("./Trigger");
Object.keys(_Trigger).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Trigger[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Trigger[key];
    }
  });
});
var _MessageEntry = require("./MessageEntry");
Object.keys(_MessageEntry).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _MessageEntry[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _MessageEntry[key];
    }
  });
});
var _Id = require("./Id");
Object.keys(_Id).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Id[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Id[key];
    }
  });
});
var _LatLng = require("./LatLng");
Object.keys(_LatLng).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _LatLng[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _LatLng[key];
    }
  });
});
var _Reportable = require("./Reportable");
Object.keys(_Reportable).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Reportable[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Reportable[key];
    }
  });
});
var _Sequenceable = require("./Sequenceable");
Object.keys(_Sequenceable).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Sequenceable[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Sequenceable[key];
    }
  });
});
var _CdgTransitionable = require("./CdgTransitionable");
Object.keys(_CdgTransitionable).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _CdgTransitionable[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _CdgTransitionable[key];
    }
  });
});
var _Transitionable = require("./Transitionable");
Object.keys(_Transitionable).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Transitionable[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Transitionable[key];
    }
  });
});
var _Payable = require("./Payable");
Object.keys(_Payable).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Payable[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Payable[key];
    }
  });
});